import { getEnvFromHostname, ENVIRONMENTS } from 'pages/utils/getEnvFromHostname';
import SocketClient from 'pages/views/devices/socketClient';
import { HUB_MESSAGES } from 'pages/views/devices/socketClient/types';
import { setOption } from 'pages/views/devices/utils/options';

$(function() {
  const navigatorLanguage = window.browserLocale().replace(/-.+/, '');
  const isWhitelistedLanguage = !!~['fr', 'nl', 'es', 'de'].indexOf(navigatorLanguage);

  window.hasLocalizejsModule =
    window.lsCloud.Modules.hasModule('i18n.localizejs') &&
    (window.lsCloud.Modules.hasModule('i18n.localizejs.locale_whitelist') || isWhitelistedLanguage);

  // use 'hTP0R29YLroxm' on dev only if necessary since it increases pageviews
  const key = getEnvFromHostname() === ENVIRONMENTS.DEVELOPMENT ? '' : 'QRMMQHUi3DHj8';

  if (window.hasLocalizejsModule && key !== '') {
    const localizeFunctions = [
      'translate',
      'untranslate',
      'phrase',
      'initialize',
      'translatePage',
      'setLanguage',
      'getLanguage',
      'detectLanguage',
      'getAvailableLanguages',
      'untranslatePage',
      'bootstrap',
      'prefetch',
      'on',
      'off',
    ];

    const localizeOptions = {
      key,
      defaultLanguage: navigatorLanguage,
      rememberLanguage: true,
      translateTitle: false,
      blockedClasses: [
        'address',
        'employee',
        'ui-timepicker-list',
        'date_range_calendars',
        'pika-single',
        'notranslate',
        'price',
        'number',
        'money',
        'view-money',
        'prettymoney',
        'view-prettymoney',
        'sum',
        'quickcash',
        'Select-input',
        'Select-value-label',
      ],
    };

    $.getScript('https://global.localizecdn.com/localize.js').done(function(script, textStatus) {
      function changeWatch(callback, ms) {
        clearTimeout(timeout);
        timeout = setTimeout(callback, ms);
      }

      let timeout;

      (function(a) {
        if (!a.Localize) {
          const functionNames = localizeFunctions;
          for (let i = 0; i < functionNames.length; i += 1) {
            a.Localize[functionNames[i]] = function() {};
          }
        }
      })(window);

      window.Localize.on('setLanguage', function(options) {
        const newLocale = options.to.replace(/-.+/, '');
        if (typeof CalendarLocale !== 'undefined') {
          window.CalendarLocale.locale = newLocale;
        }
        if (typeof ZendeskChat !== 'undefined') {
          window.ZendeskChat.locale = newLocale;
        }
        if (
          document.getElementById('custom-fields-iframe') &&
          document.getElementById('custom-fields-iframe').contentWindow.Localize
        ) {
          document
            .getElementById('custom-fields-iframe')
            .contentWindow.Localize.setLanguage(options.to);
        }

        if (window.isGriffin()) {
          window.StencilWebAPI.navigation.updateNavState();
        }

        setOption({ locale: options.to });
        SocketClient.send(HUB_MESSAGES.UPDATE_CONFIG, { config: { locale: options.to } });
      });

      if (window.isGriffin()) {
        window.Localize.on('translate', function(params) {
          if (
            params &&
            params.node &&
            params.node.className &&
            /^(?:cr|js)-topbar/.test(params.node.className)
          ) {
            changeWatch(function() {
              window.StencilWebAPI.navigation.updateNavState();
            }, 250);
          }
        });
      }

      window.Localize.initialize(localizeOptions);
    });

    if (typeof history.onChangeState === 'function') {
      window.history.onChangeState({ name: 'admin.views.custom_fields' }, function(filters) {
        if (!document.getElementById('custom-fields-iframe')) return;

        // Protection in case the iframe's content is not finished loading
        // and the initLocalizeJS method is not yet available
        const waitForLocalizeToBeAvailable = setInterval(function() {
          if (!document.getElementById('custom-fields-iframe')) {
            window.clearInterval(waitForLocalizeToBeAvailable);
            return;
          }
          if (
            typeof document.getElementById('custom-fields-iframe').contentWindow.initLocalizeJS !==
            'function'
          ) {
            return;
          }
          window.clearInterval(waitForLocalizeToBeAvailable);

          localizeOptions.targetLanguage = window.Localize.getLanguage();

          document
            .getElementById('custom-fields-iframe')
            .contentWindow.initLocalizeJS(localizeFunctions, localizeOptions);
        }, 250);
      });
    }
  }
});
